import { isDesktop } from "react-device-detect";
import FreespinStatusbarController from "../../controllers/freespin/FreeSpinStatusBarController";
import MainGridController from "../../controllers/grid/MainGridController";
import { COMPONENTS } from "../../lib/constants";
import { FreespinStatusbarGrid } from "./FreespinStatusbarGrid";

export const FreespinStatusbarView = {
  name: COMPONENTS.FREESPIN_STATUS_BAR,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: FreespinStatusbarController,
      name: "FreespinStatusBarController",
      config: {
        item: "texts",
        val: "texts",
        position: { x: 0, y: 120, w: 634 },
      },
    },
    {
      Controller: MainGridController,
      name: "FreespinStatusbarGrid",
      config: FreespinStatusbarGrid,
    },
  ],
  components: [
    {
      name: "bg",
      type: "Sprite",
      position: { x: 0, y: 0 },
      components: [
        {
          name: "bg",
          type: "Sprite",
          img: "bonus_reel_indicator",
          position: { x: 0, y: 0 },
        },
        {
          name: "win_bg_border",
          type: "AnimatedSprite",
          position: { x: 576 / 2, y: 0 },
          anchor: {
            x: 0.5,
            y: 0.5,
          },
          animation: {
            pattern: "sfs$.png",
            start: 0,
            end: 29,
            speed: 0.5,
            precision: 2,
            loop: true,
            scale: {
              x: isDesktop ? 1.3 : 2,
              y: isDesktop ? 1.3 : 2,
            },
          },
        },
        {
          name: "texts",
          type: "Sprite",
          components: [
            {
              name: "FREE_SPIN_LEFT",
              type: "Text",
              text: "FREE_SPIN_LEFT",
              position: { x: 50, y: 15 },
            },
            {
              name: "FREE_SPIN_LEFT_AMOUNT",
              type: "Text",
              text: "FREE_SPIN_LEFT_AMOUNT",
              position: { x: 255, y: 15 },
            },
            {
              name: "FREE_SPIN_WIN",
              type: "Text",
              text: "FREE_SPIN_WIN",
              position: { x: 355, y: 15 },
            },
            {
              name: "FREE_SPIN_WIN_AMOUNT",
              type: "Text",
              text: "FREE_SPIN_WIN_AMOUNT",
              position: { x: 480, y: 15 },
            },
          ],
        },
      ],
    },
  ],
};
